import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGenderUnidentified = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 20" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(0 1)">
      <path
        stroke="#179FE3"
        d="m3.512 12.47-2.33-5.286a1 1 0 0 1 1.05-1.394l1.929.265a1 1 0 0 0 .136.009H6.67a1 1 0 0 0 .134-.01l2.37-.32a.42.42 0 0 1 .47.359"
      />
      <path
        stroke="#E568B2"
        d="m7.796 8.207 2.01 3.88a1 1 0 0 1-.888 1.46H8.14a1 1 0 0 0-1 1v2.77a1 1 0 0 1-1 1H4.972a1 1 0 0 1-1-1v-2.802a1 1 0 0 0-1-1h-.504"
      />
      <circle cx={5.614} cy={2.159} r={2.159} stroke="#179FE3" />
      <path fill="#C2C5CC" d="m.437 14.839 9.9-9.9.706.708-9.899 9.899z" />
    </g>
  </svg>
);
const Memo = memo(SvgGenderUnidentified);
export default Memo;
